/**
 * Lightweight analytics tracker.
 * Pushes to GTM dataLayer (if present) and calls gtag (if loaded).
 * Safe to call even when no analytics is configured —
 * events will simply be queued in window.dataLayer for later.
 */

// Assumed monetary value per key event, so GA4 can compute ROI directly.
// Tune these to match the clinic's real cost/lead — 60 CHF for a fully
// qualified form submission, 25 CHF for a WhatsApp chat start.
export const LEAD_VALUE_CHF = 60;
export const WHATSAPP_VALUE_CHF = 25;
export const CURRENCY = "CHF";

export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
    // Helpful in dev — silent in prod if you strip console
    if (process.env.NODE_ENV !== "production") {
      console.debug("[track]", name, params);
    }
  } catch (error) {
    /* never block UX on tracking */
    if (process.env.NODE_ENV !== "production") {
      console.warn("[track] failed", name, error);
    }
  }
};
